export class UpdateAssetCommand {
    constructor(context, asset) {
        this.context = context;
        this.asset = asset;
    }
}
//# sourceMappingURL=update-asset.command.js.map